import { useFormContext } from 'react-hook-form'
import { Radio, RadioGroup } from '../../shared/compass-ui'
import TextInputError from './TextInputError'

export default function HomeRadioInput() {
  const {
    formState: { errors },
    watch,
  } = useFormContext()
  const { housing } = errors

  const selectedValue = watch('housing')
  const hasHousingError = typeof housing?.message === 'string'

  return (
    <>
      <RadioGroup
        label="Do you rent or own your home?"
        hasError={hasHousingError}
        id="housing-radio-group"
      >
        {[
          { label: 'Rent', value: 'rent' },
          { label: 'Own', value: 'own' },
          { label: 'Neither', value: 'neither' },
        ].map((option, idx) => (
          <Radio
            data-testid={`housing${option.label}`}
            key={`radio-option-for-${option.value}`}
            {...option}
            idx={idx}
            hasError={hasHousingError}
            name="housing"
            selectedValue={selectedValue}
          />
        ))}
      </RadioGroup>
      {hasHousingError && <TextInputError>This field is required</TextInputError>}
    </>
  )
}
